'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultPromotion = exports.msaOfferById = exports.promotionByAlias = exports.promotionsByMsa = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _sagaTools = require('@classpass/saga-tools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Remove when IAF is migrated to promo v2
var promotionsByMsa = exports.promotionsByMsa = (0, _sagaTools.makeEntityScaffold)('SAGA.API.PROMOTIONS_BY_MSA', function (client, msaIdentifier, promoIdentifier, params) {
  return client.promotions.getV3(promoIdentifier, (0, _extends3.default)({}, params, {
    msa_identifier: msaIdentifier
  })).then(function (promo) {
    return [promo];
  });
}, { defaultKey: [1, 2] }); /* eslint-disable import/prefer-default-export */

var promotionByAlias = exports.promotionByAlias = (0, _sagaTools.makeEntityScaffold)('SAGA.API.PROMOTION_BY_ALIAS', function (client, promoAlias, msaId, params) {
  return client.promotions.getPromotionByAlias(promoAlias, (0, _extends3.default)({}, params, msaId ? { msa_id: msaId } : {}));
}, { defaultKey: function defaultKey(client, promoAlias, msaId) {
    return msaId ? promoAlias + '_' + msaId : promoAlias;
  } });

var msaOfferById = exports.msaOfferById = (0, _sagaTools.makeEntityScaffold)('SAGA.API.MSA_OFFER_BY_ID', function (client, msaOfferId, params) {
  return client.promotions.getMsaOfferById(msaOfferId, params);
}, { defaultKey: 1 });

var defaultPromotion = exports.defaultPromotion = (0, _sagaTools.makeEntityScaffold)('SAGA.API.DEFAULT_PROMOTION', function (client, state, msaId) {
  var platform = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'web';
  return client.promotions.getDefaultPromotionForState(state, (0, _extends3.default)({
    platform: platform
  }, msaId ? { msa_id: msaId } : {})).then(function (data) {
    return data && (0, _extends3.default)({}, data, data.content);
  });
}, { defaultKey: [1, 2] });